import { Api, ModelRow, ModelSearchResult, StringUtil, UserSettings } from "@mcleod/core";
import { AutogenLayoutImagingServices } from "./autogen/AutogenLayoutImagingServices";
import { ClickEvent, TableRow, DropdownItem, TableColumn, Textbox } from "@mcleod/components";
import { text } from "stream/consumers";
import { CommonDialogs } from "@mcleod/common";
import { LMEUserSettings } from "../../../mcleod-ui-lme/general/src/settings/LMEUserSettings";

export class ImagingServices extends AutogenLayoutImagingServices {
    private tblRows: ModelRow[] = [];
    private selectedRow: TableRow;
    private timer: any;
    private regRows: any[] = [];
    private prevsvchost=null;

    override onLoad() {
        //console.log(this);
        this.GetStartsvcHostsPorts();
        //this.listServicesOnClick(null);
    }

    async GetStartsvcHostsPorts() {
        try {
            await Api.post("register-admin/nagent", {action: "refresh" }).then(response => {
            if( response )
            {
                //console.log( response );
                this.regRows = response.data;
                const items: DropdownItem[] = [];
                for (const row of this.regRows) {
                    //console.log("Row: ", row);
                    if( row.ipaddress == "66.77.88.99" )
                    //items.push( { caption: row.hostname } );
                    items.push(new DropdownItem(row.hostname, row.hostname));
                }
                this.host.items = items;
            }
            else
                CommonDialogs.showMessage("Failed to refresh.", "Document Power");
          });
        } finally {
        }
    }

    /** This is an event handler for the onClick event of listServices. */
  async listServicesOnClick(event: ClickEvent) {
    if( this.host.text.length <= 0 || this.port.text.length <= 0 )
        return;
    this.listServices.busy = true;
    try {
        await Api.post("imaging-services/startsvc", {action: "listall",
                        svchost: this.host.text, svcport: this.port.text}).then(response => {
        if( response )
        {
            //console.log( response );
            if( this.tableServices.rowCount > 0 )
                this.tableServices.clearRows();
            this.tblRows = response.data;
            //console.log("TableRow: " , this.tblRows);
            for (const row of this.tblRows) {
                //console.log(row);
                this.tableServices.addRow( row, null, { display: true, addToData: false });
            }
            this.txtCount.text = this.tblRows.length.toString(10);
        }
        else
            CommonDialogs.showMessage("Failed to refresh.", "Document Power");
      });
    } finally {
        this.listServices.busy = false;
    }
  }

/** This is an event handler for the onClick event of stopService. */
  async stopServiceOnClick(event: ClickEvent) {
    if( this.selectedRow )
    {
        const pname = this.selectedRow.data.procname;
        const status = this.selectedRow.data.status;
        let locked = 0;
        if( this.checkboxLock.checked )
            locked = 1;
        if( status == "Disabled" )
        {
            CommonDialogs.showMessage("Service: " + pname + " is disabled", "Document Power");
            return;
        }
        this.stopService.busy = true;
        try {
            await Api.post("imaging-services/startsvc", {action: "stopservice" ,
                            proc_name: pname, locked: locked}).then(response => {
                if( response )
                {
                    //this.listServicesOnClick(event);
                    //console.log( response );
                    for( let i = 0; i < this.tableServices.rowCount; i++ )
                    {
                        if( this.tableServices.rows[i] == this.selectedRow )
                        {
                            const tableRow = this.tableServices.rows[i];
                            //const modelRow = tableRow.data as ModelRow;
                            const status: Textbox = tableRow.findComponentById("txtstatus") as Textbox;
                            status.text = "Not Running";
                            break;
                        }
                    }
                }
                else
                    CommonDialogs.showMessage("Failed to stop service: " + pname, "Document Power");
                });
        } finally {
            this.stopService.busy = false;
        }
    }
    else
        CommonDialogs.showMessage("Please select a service to stop.", "Document Power");
}

/** This is an event handler for the onClick event of startService. */
  async startServiceOnClick(event: ClickEvent) {
    if( this.selectedRow )
    {
        const pname = this.selectedRow.data.procname;
        const status = this.selectedRow.data.status;
        if( status == "Disabled" )
        {
            CommonDialogs.showMessage("Service: " + pname + " is disabled", "Document Power");
            return;
        }
        this.startService.busy = true;
        try {
            await Api.post("imaging-services/startsvc", {action: "startservice" ,
                            proc_name: pname}).then(response => {
                if( response )
                {
                    this.listServicesOnClick(event);
                    //console.log( response );
                    // for( let i = 0; i < this.tableServices.rowCount; i++ )
                    // {
                    //     if( this.tableServices.rows[i] == this.selectedRow )
                    //     {
                    //         const tableRow = this.tableServices.rows[i];
                    //         //const modelRow = tableRow.data as ModelRow;
                    //         const status: Textbox = tableRow.findComponentById("txtstatus") as Textbox;
                    //         status.text = "Running";
                    //         tableRow.selected = true;
                    //         break;
                    //     }
                    // }
                }
                else
                    CommonDialogs.showMessage("Failed to start service: " + pname, "Document Power");
                });
        } finally {
            this.startService.busy = false;
        }
    }
    else
        CommonDialogs.showMessage("Please select a service to start.", "Document Power");
}

/** This is an event handler for the onClick event of restartAll. */
  async restartAllOnClick(event: ClickEvent) {
    this.restartAll.busy = true;
    try {
        await this.stopAllOnClick(event);
        await this.listServicesOnClick(event);
        await this.startAllOnClick(event);
        await this.listServicesOnClick(event);
    } finally {
        this.restartAll.busy = false;
    }
  }

/** This is an event handler for the onClick event of stopAll. */
  async stopAllOnClick(event: ClickEvent) {
    this.stopAll.busy = true;
    try {
        await Api.post("imaging-services/startsvc", {action: "stopall",
                        proc_name: "all"});
        await this.startAllOnClick(event);
    } finally {
        this.stopAll.busy = false;
    }
  }

/** This is an event handler for the onClick event of startAll. */
  async startAllOnClick(event: ClickEvent) {
    this.startAll.busy = true;
    try {
        await Api.post("imaging-services/startsvc", {action: "startall",
                        proc_name: "all"});
        await this.startAllOnClick(event);
    } finally {
        this.startAll.busy = false;
    }
  }

/** This is an event handler for the onClick event of rowService. */
  rowServiceOnClick(event: ClickEvent) {
    this.selectedRow = this.tableServices.selectedRow;
    //console.log(this.selectedRow);
  }

/** This is an event handler for the onClick event of checkboxAutoRefresh. */
checkboxAutoRefreshOnClick(event: ClickEvent) {
    if( this.checkboxAutoRefresh.checked )
        this.startAutoRefresh();
    else
        this.stopAutoRefresh();
  }

  private startAutoRefresh() {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.listServicesOnClick(null), 5000);
  }

  private stopAutoRefresh() {
    clearInterval(this.timer);
    this.timer = null;
  }

/** This is an event handler for the onChange event of host. */
  hostOnChange(event) {
    if( this.host.text != this.prevsvchost ) {
        this.prevsvchost = this.host.text;
        this.listServicesOnClick(event);
    }
  }
}

